export { default as SalesPerformance } from './primary';
